import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from "@angular/router";
import { toJSDate } from "@ng-bootstrap/ng-bootstrap/datepicker/ngb-calendar";
import { BehaviorSubject, Observable, of } from "rxjs";
import { PermissionService } from "src/app/services/permission.service";
import { Permission } from "src/app/shared/models/Permission";
import { AuthConfigService } from "./auth-config.service";
import { AuthService } from "./auth.service";
import { mergeMap } from "rxjs/operators";
import Swal from 'sweetalert2';

export const BLOCKED_ROUTE_MESSAGE_HTML = `
Por seguridad, esta funcionalidad está temporalmente deshabilitada.<br>

El Servicio de Impuestos Internos (SII) implementó recientemente cambios en su plataforma que modifican la forma en que se realizan procesos automatizados relacionados con Boletas de Honorarios.<br>

Anteriormente, las operaciones de emisión, consulta, sincronización y obtención de PDF podían realizarse mediante autenticación con RUT y contraseña de la empresa.
Este mecanismo fue restringido por el SII como parte de nuevas medidas de seguridad.<br>

Actualmente, la autenticación automatizada solo es posible mediante Certificado Digital asociado a una persona natural, lo que impide replicar el comportamiento anterior de operación por empresa.<br>

Como medida preventiva y de seguridad, el acceso a los mantenedores de:<br>
<ul style="text-align:left; margin: 8px 0 8px 18px;">
  <li>Emisión Masiva de BHE</li>
  <li>BHE Emitidas</li>
  <li>BHE Recibidas</li>
</ul>

ha sido temporalmente desactivado.<br>
Esta situación afecta exclusivamente a los servicios relacionados con Boletas de Honorarios.<br>
Nuestro equipo se encuentra evaluando alternativas para enfrentar este nuevo escenario.
Informaremos oportunamente cualquier actualización.
`;
@Injectable({
	providedIn: "root",
})
export class RoleGuard implements CanActivate {
	public static reload$ = new BehaviorSubject<void>(null);

	private static disabledRoutes: string[] = [
	];

	private basePermission: Permission = new Permission();
	//private routePermissions: Permission[] = [];
	constructor(private permissions: PermissionService, private router: Router, private config: AuthConfigService, private authService: AuthService) {}
	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return RoleGuard.reload$.pipe(
			mergeMap(() => {
				// verificar si la ruta está en la lista de rutas deshabilitadas
				if (RoleGuard.disabledRoutes.some(r => state.url.startsWith(r))) {
					// mostrar alerta de que la funcionalidad está deshabilitada temporalmente
					Swal.fire({
						title: 'Módulo de Boletas de Honorarios temporalmente deshabilitado',
						html: BLOCKED_ROUTE_MESSAGE_HTML,
						icon: 'warning',
						confirmButtonText: 'Aceptar'
					});
					return of(false);
				}

				let permission = this.permissions.getAccessPermission();
				this.basePermission = permission;
				let routePermission = this.permissions.getRoutePermission(state.url);
				if (this.basePermission && this.basePermission.asignado && routePermission) {
					return of(this.basePermission.asignado);
				} else if (!routePermission && state.url != "/inicio") {
					this.router.navigate(["/bloqueado"]); //
					return of(false);
				} else {
					this.router.navigate([this.config.LoginRoute]); //
					this.authService.logout().subscribe();
					return of(false);
				}
			})
		);
	}
}
